import { writable } from 'svelte/store';

function normalize_scene_ids(scenes_obj: Record<string, any>): Record<string, any> {
	const result = { ...scenes_obj };
	for (const [key, value] of Object.entries(result)) {
		if (value.id === undefined) {
			result[key] = { ...value, id: key };
		}
	}
	return result;
}

function create_scenes() {
	const initialScenes = normalize_scene_ids(JSON.parse(localStorage.getItem('scenes')) || {});
	const { subscribe, set, update } = writable(initialScenes);

	return {
		subscribe,
		set: (scenes) => {
			set(normalize_scene_ids(scenes));
		},
		update: (_scenes) =>
			update((scenes) => {
				// Mainly used to handle list edits for scenes from the socket event apiToUi
				// On scene add we recieve only the scene object and must add _id prop to it.
				// On edit e recieve the whole scenes list object with _id prop already present.
				if (Object.keys(_scenes).length === 1) {
					console.log('Add one scene from socket APItoUI');
					let newId = Object.keys(_scenes)[0].toString();
					const incomingScene = Object.values(_scenes)[0];
					const existingScene = scenes[newId];

					const merged = {
						//@ts-ignore
						...incomingScene,
						_id: newId,
						id: newId,
					};

					// Preserve frontend-only _meta.new flag for pulse animation
					// Prevents socket updates from wiping pulse animation state
					if (existingScene?._meta?.new && merged?._meta && !merged?._meta?.new) {
						merged._meta = { ...merged._meta, new: existingScene._meta.new };
					}

					return { ...scenes, [newId]: merged };
				}

				// In the context of a sub-account, retain the rights value when the scene is changed in the master account.
				for (const [key, value] of Object.entries(_scenes)) {
					const oldScene = scenes?.[key];
					if (typeof oldScene?._meta?.rights !== 'undefined') {
						(value as any)._meta.rights = oldScene._meta.rights;
					}
					// Preserve frontend-only _meta.new flag for pulse animation
					if (oldScene?._meta?.new && (value as any)?._meta && !(value as any)._meta.new) {
						(value as any)._meta.new = oldScene._meta.new;
					}
				}
				return { ...scenes, ...normalize_scene_ids(_scenes) };
			}),
		clearNewFlag: (id) =>
			update((scenes) => {
				if (scenes[id]) {
					delete scenes[id]._meta?.new;
				}
				return { ...scenes };
			}),
		remove: (id) =>
			update((scenes) => {
				console.log('DELETE SCENE ', id);
				delete scenes[id];
				return scenes;
			}),
		addScene: (scene) =>
			update((scenes) => {
				if (typeof scene._id !== 'undefined') {
					let newId = scene._id.toString(); // id should be string. BE might return number
					scene._name = newId; // PHP-API legacy identifier. PHP-API bulk_update relies on it on REORDER
					scene._id = newId;
					scene.id = newId;

					return { ...scenes, [newId]: scene };
				}
				return scenes;
			}),
		editScene: (editedScene) =>
			update((scenes) => {
				console.log('EDIT SCENE HTTP ', editedScene);
				if (!editedScene.id) editedScene.id = editedScene._id;
				scenes[editedScene._id] = editedScene;
				return scenes;
			}),
		bulkEditScenes: (editedScenes: {}) =>
			update((scenes) => {
				console.log('BULK SCENES UPDATE ', editedScenes);
				return { ...scenes, ...normalize_scene_ids(editedScenes as Record<string, any>) };
			}),
		reset: () => set({}),
	};
}

export const scenes: any = create_scenes();

scenes.subscribe((val) => {
	localStorage.setItem('scenes', JSON.stringify(val));
});
